export interface NavigationParams {
  integration?: string;
  findingThreadId?: string;
  violation?: string;
  resource?: string;
  violationRule?: string;
  policy?: string;
  platform?: string;
  playbookId?: string;
  agentStep?: string;
  finding?: string;
  stepThreadId?: string;
  issue?: string;
  preventionId?: string;
  showPrevention?: boolean;
  inLineControl?: string;
  dataItem?: string;
  ruleType?: 'detection' | 'violation';
  redTeamSession?: string;
}

export enum QueryParams {
  integration = 'integration',
  violation = 'violation',
  resource = 'resource',
  violationRule = 'violationRule',
  policy = 'policy',
  agentStep = 'agentStep',
  finding = 'finding',
  findingThreadId = 'findingThreadId',
  issue = 'issue',
  stepThreadId = 'stepThreadId',
  prevention = 'preventionId',
  inLineControl = 'inLineControl',
  dataItem = 'dataItem',
  ruleType = 'ruleType',
  redTeamSession = 'redTeamSession',
}
